import { formatPrice } from "@/lib/store";
import { BATTERY_MIN, hasBattery, TRADE_PARTS } from "@/lib/tradeCatalog";
import { chip } from "../OrderSpecFields";
import { Question, Choices, YesNo, CheckBox, tradeInput } from "./TradeParts";

const MARKS = [["nenhuma", "Nenhuma"], ["leves", "Leves"], ["moderadas", "Moderadas"], ["severas", "Severas"]];

// Perguntas 3 a 6 (bateria, caixa, peças, marcas) + tela e tampa trincadas e compra na RC, que entram no cálculo.
export const TradeCondition = ({ f, setF, sfx = "", bonus = 0 }) => {
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));
  const battery = hasBattery(f.category);
  return (
    <>
      {battery && (
        <Question n={3} label="Saúde da bateria" hint={`Ajustes > Bateria > Saúde da Bateria. Abaixo de ${BATTERY_MIN}% entra troca de bateria.`} testid={`trade-q-battery${sfx}`}>
          <div className="flex items-center gap-2">
            <input data-testid={`trade-battery-input${sfx}`} inputMode="numeric" value={f.battery} placeholder="Ex: 87"
              onChange={(e) => set("battery")(e.target.value.replace(/\D/g, "").slice(0, 3))} className={`${tradeInput} max-w-[140px]`} />
            <span className="text-sm text-zinc-300">%</span>
          </div>
        </Question>
      )}
      <Question n={battery ? 4 : 3} label="Possui caixa?" testid={`trade-q-box${sfx}`}>
        <YesNo testid={`trade-box${sfx}`} value={f.has_box} onChange={set("has_box")} />
      </Question>
      <Question n={battery ? 5 : 4} label="Possui peças trocadas?" hint="Ajustes > Geral > Sobre > Histórico de Peças e Serviço" testid={`trade-q-parts${sfx}`}>
        <YesNo testid={`trade-parts${sfx}`} value={f.parts_replaced} onChange={set("parts_replaced")} />
        {f.parts_replaced && (
          <>
            <p className="mt-3 text-xs text-zinc-400">Quais peças? Toque em todas que foram trocadas.</p>
            <div className="mt-2 flex flex-wrap gap-2">
              {TRADE_PARTS.map(([id, label]) => {
                const on = (f.parts || []).includes(id);
                return (
                  <button type="button" key={id} data-testid={`trade-part-${id}${sfx}`} aria-pressed={on} className={chip(on)}
                    onClick={() => setF((s) => ({ ...s, parts: on ? s.parts.filter((x) => x !== id) : [...(s.parts || []), id] }))}>{label}</button>
                );
              })}
            </div>
            {(f.parts || []).includes("outra") && (
              <input data-testid={`trade-parts-detail${sfx}`} value={f.parts_detail} maxLength={120} onChange={(e) => set("parts_detail")(e.target.value)} placeholder="Qual peça? Ex: Face ID, alto-falante" className={`${tradeInput} mt-3`} />
            )}
          </>
        )}
        <div className="mt-4">
          <CheckBox testid={`trade-unknown-part${sfx}`} on={!!f.unknown_part} onChange={set("unknown_part")} title='Aparece "Peça desconhecida" no aparelho'
            hint="Marque se em Ajustes > Geral > Sobre aparece o aviso de peça desconhecida (peça não original)." />
        </div>
      </Question>
      <Question n={battery ? 6 : 5} label="Apresenta marcas de uso?" testid={`trade-q-marks${sfx}`}>
        <Choices testid={`trade-marks${sfx}`} value={f.marks} options={MARKS} onChange={set("marks")} />
      </Question>
      <Question label="A tela está trincada?" testid={`trade-q-screen${sfx}`}>
        <YesNo testid={`trade-screen${sfx}`} value={f.screen_cracked} onChange={set("screen_cracked")} />
      </Question>
      <Question label="A tampa traseira (ou carcaça) está trincada?" testid={`trade-q-back${sfx}`}>
        <YesNo testid={`trade-back${sfx}`} value={f.back_cracked} onChange={set("back_cracked")} />
      </Question>
      <div className="rounded-[22px] border border-white/10 bg-white/[0.03] p-4 sm:p-5">
        <CheckBox testid={`trade-bought-at-rc${sfx}`} on={!!f.bought_at_rc} onChange={set("bought_at_rc")} title="Aparelho comprado na RC iPhones"
          hint={bonus > 0 ? `Ganhe ${formatPrice(bonus)} de bônus na avaliação. A loja confere a compra pelo WhatsApp.` : "A loja confere a compra pelo WhatsApp."} />
      </div>
    </>
  );
};
